export const enum TipAmountType {
  TEN_PERCENT = 0.1,
  FIFTEEN_PERCENT = 0.15,
  TWENTY_PERCENT = 0.2,
  CUSTOM = -1,
}
